export const movieCategories = [
  { slug: 'all', name: '全部', icon: 'ri-movie-line' },
  { slug: 'action', name: '动作片', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '喜剧片', icon: 'ri-emotion-laugh-line' },
  { slug: 'scifi', name: '科幻片', icon: 'ri-rocket-line' },
  { slug: 'romance', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'horror', name: '恐怖片', icon: 'ri-ghost-line' },
  { slug: 'animation', name: '动画片', icon: 'ri-palette-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-film-line' },
  { slug: 'classic', name: '经典片', icon: 'ri-vip-crown-line' },
];

export const featuredMovies = [
  {
    id: 'movie-1',
    title: '星际穿越',
    titleEn: 'Interstellar',
    category: 'scifi',
    year: 2014,
    rating: 9.4,
    duration: '169分钟',
    director: '克里斯托弗·诺兰',
    cast: ['马修·麦康纳', '安妮·海瑟薇', '杰西卡·查斯坦'],
    image: 'https://readdy.ai/api/search-image?query=Interstellar%20movie%20scene%20space%20black%20hole%20astronaut%20dramatic%20cinematic%20lighting%20epic%20sci-fi%20atmosphere%20dark%20cosmic%20background%20film%20poster%20style&width=800&height=600&seq=movie-interstellar&orientation=landscape',
    description: '近未来的地球黄沙遍野，人类面临着巨大的生存危机。前NASA宇航员库珀在女儿墨菲的书房里发现了奇怪的重力场现象，这引导他前往一个秘密的NASA基地。在那里，布兰德教授告诉他，人类必须寻找新的家园。库珀告别女儿，与布兰德博士、罗米利、道尔一起踏上了穿越虫洞的星际旅程。他们面临时间膨胀、极端环境等挑战，而库珀最终发现自己与女儿之间的爱，才是超越时空维度的真正力量。',
    tags: ['科幻', '冒险', '亲情'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-2',
    title: '肖申克的救赎',
    titleEn: 'The Shawshank Redemption',
    category: 'classic',
    year: 1994,
    rating: 9.7,
    duration: '142分钟',
    director: '弗兰克·德拉邦特',
    cast: ['蒂姆·罗宾斯', '摩根·弗里曼'],
    image: 'https://readdy.ai/api/search-image?query=Shawshank%20Redemption%20prison%20scene%20rain%20freedom%20dramatic%20cinematic%20lighting%20hope%20theme%20dark%20moody%20atmosphere%20classic%20film%20poster%20style&width=800&height=600&seq=movie-shawshank&orientation=landscape',
    description: '银行家安迪·杜佛兰被误判谋杀妻子及其情人，被判处终身监禁，关进肖申克监狱。在监狱中，他结识了囚犯瑞德，两人成为挚友。安迪凭借自己的金融才能为狱警处理税务，逐渐获得典狱长的信任。然而，当他发现真凶的证据时，典狱长为了私利销毁了证据。安迪用了近二十年的时间，凭借惊人的毅力和智慧，最终重获自由，并在墨西哥的海边等待着老友瑞德的到来。',
    tags: ['经典', '励志', '剧情'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-3',
    title: '流浪地球2',
    titleEn: 'The Wandering Earth II',
    category: 'scifi',
    year: 2023,
    rating: 8.3,
    duration: '173分钟',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢'],
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20film%20space%20station%20earth%20engines%20dramatic%20cinematic%20epic%20scale%20futuristic%20technology%20dark%20cosmic%20background%20film%20poster%20style&width=800&height=600&seq=movie-wandering-earth&orientation=landscape',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。数字生命计划与移山计划的冲突，让人类的命运悬于一线。在月球危机中，各国航天员携手合作，谱写了一曲人类命运共同体的壮丽史诗。',
    tags: ['科幻', '灾难', '国产'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'movie-4',
    title: '泰坦尼克号',
    titleEn: 'Titanic',
    category: 'romance',
    year: 1997,
    rating: 9.4,
    duration: '194分钟',
    director: '詹姆斯·卡梅隆',
    cast: ['莱昂纳多·迪卡普里奥', '凯特·温斯莱特'],
    image: 'https://readdy.ai/api/search-image?query=Titanic%20movie%20romantic%20ship%20bow%20sunset%20ocean%20dramatic%20cinematic%20lighting%20classic%20love%20story%20epic%20romance%20film%20poster%20style&width=800&height=600&seq=movie-titanic&orientation=landscape',
    description: '1912年，泰坦尼克号启航。穷画家杰克和贵族少女露丝在船上相识相爱。杰克带露丝体验真正的生活，两人坠入爱河。然而巨轮撞上冰山，在生死关头，杰克把生存的机会留给了露丝。年迈的露丝回忆道："他拯救了我，在每一方面。"这段跨越阶级的爱情，成为电影史上最动人的传奇。',
    tags: ['爱情', '经典', '灾难'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-5',
    title: '功夫',
    titleEn: 'Kung Fu Hustle',
    category: 'comedy',
    year: 2004,
    rating: 8.8,
    duration: '99分钟',
    director: '周星驰',
    cast: ['周星驰', '元华', '元秋', '黄圣依'],
    image: 'https://readdy.ai/api/search-image?query=Kung%20Fu%20Hustle%20movie%20scene%20martial%20arts%20comedy%20pig%20sty%20alley%20dramatic%20cinematic%20action%20Chinese%20style%20film%20poster&width=800&height=600&seq=movie-kungfu&orientation=landscape',
    description: '1940年代的上海，小混混阿星一心想加入势力庞大的斧头帮。他来到猪笼城寨敲诈勒索，却意外引来了真正的武林高手。斧头帮与猪笼城寨的居民展开了一场惊天动地的对决。阿星在关键时刻觉醒了体内的武学天赋，以如来神掌击败了终极反派火云邪神，最终与童年的棒棒糖女孩重逢。',
    tags: ['喜剧', '动作', '周星驰'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-6',
    title: '千与千寻',
    titleEn: 'Spirited Away',
    category: 'animation',
    year: 2001,
    rating: 9.4,
    duration: '125分钟',
    director: '宫崎骏',
    cast: ['柊瑠美', '入野自由', '夏木真理'],
    image: 'https://readdy.ai/api/search-image?query=Spirited%20Away%20Studio%20Ghibli%20anime%20bathhouse%20spirit%20world%20magical%20fantasy%20Japanese%20animation%20colorful%20artistic%20film%20poster%20style&width=800&height=600&seq=movie-spirited&orientation=landscape',
    description: '少女千寻和父母在搬家途中误入了一个神秘的世界。父母因贪吃变成了猪，千寻为了拯救父母，在汤婆婆的浴场工作。在白龙的帮助下，千寻逐渐成长，学会了勇敢和坚强。她帮助无脸男找回自我，解救了白龙，最终成功带父母回到了人类世界。这是一部关于成长、勇气和爱的奇幻动画杰作。',
    tags: ['动画', '奇幻', '成长'],
    isHot: true,
    isNew: false,
  },
];

export const latestMovies = [
  {
    id: 'movie-7',
    title: '奥本海默',
    titleEn: 'Oppenheimer',
    category: 'classic',
    year: 2023,
    rating: 8.8,
    duration: '180分钟',
    director: '克里斯托弗·诺兰',
    cast: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙'],
    image: 'https://readdy.ai/api/search-image?query=Oppenheimer%20movie%20atomic%20bomb%20scientist%20intense%20dramatic%20black%20white%20cinematic%20portrait%20historical%20biopic%20film%20poster%20style&width=800&height=600&seq=movie-oppenheimer&orientation=landscape',
    description: '讲述了美国"原子弹之父"罗伯特·奥本海默在二战期间领导曼哈顿计划，研制出世界上第一颗原子弹的故事。影片深入探讨了科学、道德与政治的复杂关系，展现了这位天才物理学家内心的挣扎与矛盾。',
    tags: ['传记', '历史', '剧情'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'movie-8',
    title: '满江红',
    titleEn: 'Full River Red',
    category: 'action',
    year: 2023,
    rating: 7.6,
    duration: '159分钟',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20ancient%20courtyard%20Song%20dynasty%20soldiers%20dramatic%20cinematic%20lighting%20dark%20moody%20atmosphere%20film%20poster%20style&width=800&height=600&seq=movie-full-river-red&orientation=landscape',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。金国使者死在宰相驻地，所携密信不翼而飞。小兵张大与亲兵营副统领孙均被卷入这场巨大的阴谋之中，层层反转中，真相逐渐浮出水面。',
    tags: ['悬疑', '历史', '国产'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'movie-9',
    title: '铃芽之旅',
    titleEn: 'Suzume',
    category: 'animation',
    year: 2023,
    rating: 7.7,
    duration: '122分钟',
    director: '新海诚',
    cast: ['原菜乃华', '松村北斗', '深津绘里'],
    image: 'https://readdy.ai/api/search-image?query=Suzume%20anime%20movie%20door%20fantasy%20Japanese%20landscape%20beautiful%20sky%20colorful%2C%20artistic%20animation%20film%20poster%20style%20with%20warm%20lighting&width=800&height=600&seq=movie-suzume&orientation=landscape',
    description: '17岁少女铃芽遇见了一位寻找"门"的神秘青年草太。两人一起踏上旅程，关闭散布在日本各地废墟中的灾厄之门。这是一部关于治愈创伤、面对过去的公路电影，融合了奇幻、冒险与青春成长元素。',
    tags: ['动画', '奇幻', '冒险'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'movie-10',
    title: '釜山行',
    titleEn: 'Train to Busan',
    category: 'horror',
    year: 2016,
    rating: 8.6,
    duration: '118分钟',
    director: '延尚昊',
    cast: ['孔刘', '郑裕美', '马东锡'],
    image: 'https://readdy.ai/api/search-image?query=Train%20to%20Busan%20zombie%20movie%20train%20scene%20survival%20horror%20dramatic%20dark%20cinematic%20tension%20Korean%20film%20poster%20style&width=800&height=600&seq=movie-train-to-busan&orientation=landscape',
    description: '一种神秘的病毒在韩国扩散，感染者会变成丧尸。一列开往釜山的高速列车上，乘客们必须在密闭空间内与丧尸展开生死搏斗。基金经理石宇带着女儿秀安踏上了这趟列车，在灾难面前，人性的善恶被放大到极致。',
    tags: ['恐怖', '灾难', '人性'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-11',
    title: '你好，李焕英',
    titleEn: 'Hi, Mom',
    category: 'comedy',
    year: 2021,
    rating: 8.1,
    duration: '128分钟',
    director: '贾玲',
    cast: ['贾玲', '张小斐', '沈腾', '陈赫'],
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20film%201980s%20nostalgic%20factory%20setting%20warm%20family%20emotional%20cinematic%20lighting%20retro%20style%20film%20poster&width=800&height=600&seq=movie-hi-mom&orientation=landscape',
    description: '刚考上大学的女孩贾晓玲意外穿越到1981年，与年轻时的母亲李焕英相遇。她决定让母亲过上更好的生活，帮助母亲在排球比赛中获胜，撮合母亲与厂长儿子的姻缘。然而，当她即将回到现实时，才发现母亲也穿越了回来，所有的快乐时光都是母亲给予她的最后礼物。',
    tags: ['喜剧', '亲情', '穿越'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-12',
    title: '盗梦空间',
    titleEn: 'Inception',
    category: 'scifi',
    year: 2010,
    rating: 9.3,
    duration: '148分钟',
    director: '克里斯托弗·诺兰',
    cast: ['莱昂纳多·迪卡普里奥', '约瑟夫·戈登-莱维特', '艾伦·佩吉'],
    image: 'https://readdy.ai/api/search-image?query=Inception%20movie%20dream%20city%20folding%20surreal%20mind-bending%20cinematic%20sci-fi%20thriller%20dark%20atmospheric%20film%20poster%20style&width=800&height=600&seq=movie-inception&orientation=landscape',
    description: '道姆·柯布是一个专门潜入他人梦境窃取秘密的高手。他接受了一项看似不可能的任务：在目标人物的潜意识中植入一个想法。为了完成这个任务并回到孩子们身边，柯布组建了一支精英团队，深入多层梦境之中。然而，在梦境的深处，他必须面对自己亡妻的幽灵。',
    tags: ['科幻', '悬疑', '动作'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-13',
    title: '这个杀手不太冷',
    titleEn: 'Léon: The Professional',
    category: 'action',
    year: 1994,
    rating: 9.4,
    duration: '110分钟',
    director: '吕克·贝松',
    cast: ['让·雷诺', '娜塔莉·波特曼', '加里·奥德曼'],
    image: 'https://readdy.ai/api/search-image?query=Leon%20the%20Professional%20movie%20hitman%20girl%20urban%20street%20dramatic%20cinematic%20dark%20moody%20atmosphere%20classic%20film%20poster%20style&width=800&height=600&seq=movie-leon&orientation=landscape',
    description: '职业杀手莱昂独居在纽约小意大利区。邻家女孩玛蒂尔达的家人被黑警斯坦斯菲尔德杀害，她敲开了莱昂的门寻求庇护。两人之间建立起一种超越年龄的奇特感情。莱昂教玛蒂尔达使用枪支，玛蒂尔达教莱昂读书识字。最终，莱昂为保护玛蒂尔达付出了生命的代价。',
    tags: ['动作', '剧情', '经典'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-14',
    title: '寻梦环游记',
    titleEn: 'Coco',
    category: 'animation',
    year: 2017,
    rating: 9.1,
    duration: '105分钟',
    director: '李·昂克里奇',
    cast: ['安东尼·冈萨雷斯', '盖尔·加西亚·贝纳尔'],
    image: 'https://readdy.ai/api/search-image?query=Coco%20Pixar%20animation%20Day%20of%20the%20Dead%20Mexican%20culture%20colorful%20warm%20magical%20glowing%20fantasy%20family%20film%20poster%20style&width=800&height=600&seq=movie-coco&orientation=landscape',
    description: '12岁的墨西哥小男孩米格尔热爱音乐，但他的家族却世代禁止音乐。在亡灵节这天，米格尔意外进入了亡灵世界，遇见了已故的曾曾祖父。为了回到现实世界，米格尔必须在日出前得到家人的祝福。在这段奇妙的旅程中，他揭开了家族尘封多年的秘密。',
    tags: ['动画', '音乐', '家庭'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-15',
    title: '饮食男女',
    titleEn: 'Eat Drink Man Woman',
    category: 'classic',
    year: 1994,
    rating: 9.1,
    duration: '124分钟',
    director: '李安',
    cast: ['郎雄', '吴倩莲', '杨贵媚', '王渝文'],
    image: 'https://readdy.ai/api/search-image?query=Chinese%20family%20dinner%20table%20traditional%20cuisine%20Taiwanese%20film%20warm%20atmospheric%20dramatic%20family%20drama%20film%20poster%20style&width=800&height=600&seq=movie-eat-drink&orientation=landscape',
    description: '老朱是台北一位退休的大厨，每周日都会精心准备一桌丰盛的晚宴，与三个女儿团聚。然而，每个人都有自己的人生抉择和秘密。大女儿家珍是虔诚的基督徒，二女儿家倩事业有成，小女儿家宁还在读书。随着女儿们各自找到归宿，老朱也做出了令人意外的决定。',
    tags: ['家庭', '剧情', '经典'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-16',
    title: '地球脉动',
    titleEn: 'Planet Earth',
    category: 'documentary',
    year: 2006,
    rating: 9.8,
    duration: '11集',
    director: '艾雷斯泰·法瑟吉尔',
    cast: ['大卫·爱登堡'],
    image: 'https://readdy.ai/api/search-image?query=Planet%20Earth%20documentary%20nature%20wildlife%20epic%20landscape%20animals%20stunning%20cinematic%20natural%20beauty%20BBC%20film%20poster%20style&width=800&height=600&seq=movie-planet-earth&orientation=landscape',
    description: 'BBC制作的史诗级自然纪录片，用震撼的镜头记录了地球各地的自然奇观和野生动物。从南极到北极，从高山到深海，从沙漠到雨林，展现了地球上最壮观的自然景观和最动人的生命故事。每一帧画面都堪称艺术品。',
    tags: ['自然', '纪录', 'BBC'],
    isHot: false,
    isNew: false,
  },
];

export const allMovies = [...featuredMovies, ...latestMovies];

export const getMoviesByCategory = (categorySlug: string) => {
  if (categorySlug === 'all') return allMovies;
  return allMovies.filter(m => m.category === categorySlug);
};

export const getMovieById = (id: string) => {
  return allMovies.find(m => m.id === id);
};